import Dropzone from './Dropzone.vue'

export default Dropzone
